<template>
    <div>
        <p>Initializing household...</p>
        <p v-text="errorMessage" style="color:red"/>
    </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    data() {
        return {
            errorMessage : null
        }
    },

    computed: {
        ...mapGetters('auth', ['defaultPageName'])
    },

    created() {
        this.$store.dispatch('auth/browseAsAdmin').then((isAdmin) => {
            if (isAdmin) {
                this.$store.dispatch('household/fetchHousehold', this.$store.state.auth.user.household_id).then(() => {
                    this.$store.dispatch('individuals/loadIndividuals');
                    this.$store.dispatch('individuals/loadIndividualsDropdown');
                    this.$store.dispatch('beneficiaries/loadBeneficiaries');
                    this.$store.dispatch('constants/loadConstants');
                    this.$store.dispatch('advisor/loadAdvisor');
                    this.$store.dispatch('settings/loadTooltips');
                    return Promise.all([
                        this.$store.dispatch('household/fetchIntegrationStatus'),
                        this.$store.dispatch('company/loadCompany')
                    ]);
                }).then(() => {
                    // Wait for integrations status to set then we can render the navigations properly.
                    this.$router.push({ name: this.defaultPageName });
                });
                return;
            }
            this.errorMessage = 'Permission denied'
        });
    }
}
</script>
